<template>
  <div
    v-if="!$freeParticulier() || $hasAtLeastOneGuest()"
    @keydown="progressbar.userKeyDown()"
    @keyup="progressbar.userKeyUp()"
    @click="calculate_progress"
  >
    <!-- Popup modal create evaluation -->
    <create-evaluation-popup
      :is-opened="show_add_evaluation"
      :date-debut="form.date_debut_evaluation"
      :date-fin="form.date_fin_evaluation"
      @close="show_add_evaluation = false"
      @changeDateDebut="
        (newValue) => {
          if (
            form.date_fin_evaluation == '' ||
            $verifyDates({ debut: newValue, fin: form.date_fin_evaluation })
          ) {
            form.date_debut_evaluation = newValue;
          } else {
            badDates();
            form.date_debut_evaluation = '';
          }
        }
      "
      @changeDateFin="
        (newValue) => {
          if (
            form.date_debut_evaluation == '' ||
            $verifyDates({ debut: form.date_debut_evaluation, fin: newValue })
          ) {
            form.date_fin_evaluation = newValue;
          } else {
            badDates();
            form.date_fin_evaluation = '';
          }
        }
      "
      @createEvaluation="create_evaluation"
    />
    <!-- END Popup modal create evaluation -->

    <!-- BEGIN Popup to confirm to close an evaluation -->
    <close-evaluation-popup
      :is-opened="confirmCloseEvaluation > -1"
      :is-step-one="confirmCloseEvaluation == 0"
      :is-step-two="confirmCloseEvaluation == 1"
      :today="today"
      @close="confirmCloseEvaluation = -1"
      @closeEval="close_eval"
    />
    <!-- END Popup to confirm to close an evaluation -->

    <h3 class="my-15 w-full">
      {{
        !$freeParticulier() && !$isGuest()
          ? infosPage.libelle_template
          : infosPage.libelle_page
      }}
    </h3>

    <!-- BEGIN Button add evaluation -->
    <div
      v-if="
        form.date_debut_evaluation == '' ||
        form.date_fin_evaluation == '' ||
        form.id_ref == 0 ||
        form.template == {} ||
        ($freeParticulier() && !$hasAtLeastOneGuest())
      "
    >
      <div
        v-if="role === constants.ROLE_BENEFICIAIRE"
        class="flex justify-center mb-10"
      >
        <change-structure-input class="w-max" />
      </div>
      <div
        v-if="
          $can(infosPage.name_page + '_edit', infosPass.id_pass) &&
          role !== constants.ROLE_BENEFICIAIRE &&
          !$freeParticulier()
        "
      >
        <div class="flex justify-center w-full">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-indigo-600"
            bg-color-square="bg-indigo-600"
            icon-color="text-white"
            libelle="AJOUTER UNE ÉVALUATION"
            :uppercase="true"
            icon="plus-circle"
            type-shadow="shadow-indigo"
            @clickAction="show_add_evaluation = true"
          />
        </div>
        <div class="flex justify-center w-full">
          <illustration name="evaluation" class="mt-15" />
        </div>
      </div>
      <div v-else-if="$freeParticulier()">
        <div class="text-indigo-600 text-lg text-center">
          Votre invité n'a pas ouvert d'évaluation, il n'est donc pas possible
          de s'évaluer actuellement.
        </div>
        <div class="flex justify-center w-full">
          <illustration name="notAllowed" class="mt-15" />
        </div>
      </div>
      <div v-else>
        <div class="text-indigo-600 text-lg text-center">
          Il n’y a pas d’évaluation en cours
          <span v-if="listEvaluations.length > 0">
            , vous pouvez consulter
            <br />
            vos évaluations précédentes dans l’historique ci-dessous
          </span>
          .
        </div>
        <div class="flex justify-center w-full">
          <illustration name="notAllowed" class="mt-15" />
        </div>
      </div>
    </div>
    <!-- END Button add evaluation -->

    <!-- BEGIN Evaluation content -->
    <div v-else>
      <div
        v-if="role === constants.ROLE_BENEFICIAIRE"
        class="flex justify-center mb-10"
      >
        <change-structure-input class="w-max" />
      </div>

      <!-- data comes from CompetenceChart mixin -->
      <PopupCompareCarto
        :compare-carto="compareCarto"
        @close="closeCompare"
        @changeCompare="
          (index) => {
            changeCompare(index);
          }
        "
        :carto-to-compare="cartoToCompare"
        :history-to-display="historyToDisplay"
        :competences-cles="{}"
        :history-competences-cles="[]"
        :competences-informatique="{}"
        :history-competences-informatique="[]"
        :competences-linguistique="{}"
        :history-competences-linguistique="[]"
        :competences-socio-pro="competencesSocioPro"
        :history-competences-socio-pro="historiesToCompare"
        v-if="compareCarto"
      />

      <!-- Bloc action buttons -->
      <div
        v-if="
          role !== constants.ROLE_BENEFICIAIRE &&
          !user.is_particulier &&
          $can(infosPage.name_page + '_edit', infosPass.id_pass)
        "
        class="w-full mb-10 2xl:mb-20 flex justify-center"
      >
        <list-action-buttons
          :today="today"
          :libelle-template="infosPage.libelle_template"
          :can-compare-cartography="canCompare && listEvaluations.length > 0"
          :can-compare-but-not-enough-evaluation="
            canCompare && listEvaluations.length === 0
          "
          @confirmCloseEvaluation="confirmCloseEvaluation = 0"
          @displayCompareCarto="
            displayCompareCarto('sociopro/' + infosPage.name_page)
          "
        />
      </div>
      <!-- Bloc action buttons -->

      <CheckboxIndigo class="ml-10 mb-4" libelle="Mode simplifié" v-if="form.template[0].criterions?.length > 1 && form.template[0].criterions?.length < 6" :value="jauge" @input="toggleJaugeDisplay">
      </CheckboxIndigo>
      <!-- Remplir avec le modèle de page correspondant -->

      <!-- display as a table -->
      <div v-if="!$isMobile()">
        <div
          class="text-lg text-gray-600 grid grid-cols-12 gap-x-4 content-start h-16 2xl:h-24"
        >
          <div class="mx-10 col-span-5">Intitulé</div>
          <div class="col-span-2 text-center">Auto-évaluation</div>
          <div
            @mouseover="isDisplayLastEvalTooltip = true"
            @mouseleave="isDisplayLastEvalTooltip = false"
            class="col-span-2 text-center"
            :class="{ hidden: infosPass.id_pass == user.id }"
          >
            <info-bulle-hover
              :is-display-tooltip="isDisplayLastEvalTooltip"
              name="lastEvalTooltip"
              libelle="Dernière évaluation du référent"
            />
            <span>Dernière éval.ref</span>
          </div>
          <div class="col-span-2 text-center">
            <span
              @mouseover="isDisplayEvalRefTooltip = true"
              @mouseleave="isDisplayEvalRefTooltip = false"
              :class="{ hidden: infosPass.id_pass == user.id }"
            >
              <info-bulle-hover
                :is-display-tooltip="isDisplayEvalRefTooltip"
                name="evalRefTooltip"
                libelle="Nouvelle évaluation du référent"
              />
              Nouvelle éval.ref
            </span>
          </div>
          <div
            @mouseover="isDisplayCommentairesTooltip = true"
            @mouseleave="isDisplayCommentairesTooltip = false"
            class="mr-10 col-span-1 text-center"
            :class="{ hidden: infosPass.id_pass == user.id }"
          >
            <info-bulle-hover
              :is-display-tooltip="isDisplayCommentairesTooltip"
              name="commentairesTooltip"
              libelle="Commentaires"
            />
            <span>Comm.</span>
          </div>

          <!-- BEGIN line for pictograms -->
          <!-- beneficiary always auto evaluation -->
          <div
            class="col-start-6 col-span-2 flex items-center justify-center"
            :class="{
              hidden: infosPass.id_pass == user.id,
              'cursor-help': !$can(
                'compsocio_auto_eval_read',
                infosPass.id_pass
              ),
              'cursor-pointer': $can(
                'compsocio_auto_eval_read',
                infosPass.id_pass
              ),
            }"
            @click.stop="
              $can('compsocio_auto_eval_read', infosPass.id_pass)
                ? hide('autoEval')
                : null
            "
            :title="
              $can('compsocio_auto_eval_read', infosPass.id_pass)
                ? null
                : 'Permission manquante'
            "
          >
            <icon
              :name="autoHidden ? 'eye-off' : 'eye'"
              class="h-3 w-4 text-pink-600"
            />
            <span class="ml-3 text-sm select-none">{{
              autoHidden ? 'Afficher' : 'Masquer'
            }}</span>
          </div>
          <!-- beneficiary cannot display last evaluation -->
          <div
            class="col-span-2 flex items-center justify-center cursor-pointer"
            :class="{ hidden: infosPass.id_pass == user.id }"
            @click.stop="hide('lastEval')"
          >
            <icon
              :name="lastHidden ? 'eye-off' : 'eye'"
              class="h-3 w-4 text-pink-600"
            />
            <span class="ml-3 text-sm select-none">{{
              lastHidden ? 'Afficher' : 'Masquer'
            }}</span>
          </div>
          <div class="col-span-2" />
        </div>
        <!-- END line for pictograms -->

        <div
          v-for="(intitule, index) in this.form.template[1].criterions"
          :key="index"
          class="even:bg-gray-200 even:bg-opacity-50 grid grid-cols-12 gap-x-4 content-center py-5 xl:min-h-24 2xl:min-h-32 items-center"
        >
          <div
            class="col-span-1 mx-auto pl-4 w-min-content w-min justify-center flex flex-col"
          >
            <info-bulle :libelle="intitule.libelle" :name="intitule.libelle" />
          </div>

          <div class="col-span-1 flex">
            <TextToSpeech
              :speak="intitule.description"
              :withBars="false"
            ></TextToSpeech>
          </div>

          <label for="comprehension_ecrite" class="col-span-3 my-5 text-base">
            {{ intitule.description }}
          </label>

          <AnswerJauge
            v-if="!autoHidden && jauge"
            class="md:col-span-2"
            :disabled="false"
            :criteria="form.template[0].criterions"
            :reduced="false"
            :selected="form.items[index].autoEval"
            @select="(answerIndex) => select(index, 'autoEval', answerIndex, form.template[0].criterions)"
          ></AnswerJauge>
          <input-select
            v-if="!autoHidden && !jauge"
            class="md:col-span-2 lg:justify-self-center"
            :name="index + 'auto_eval'"
            libelle=""
            :disabled="autoEvalDisabled"
            :datas="form.template[0].criterions"
            :value="form.items[index].autoEval"
            @input="(newValue) => select(index, 'autoEval', newValue, form.template[0].criterions)"
          />

          <!-- if auto eval is hidden -->
          <div v-if="autoHidden" class="col-span-2 justify-self-center" />

          <input-text
            v-if="!lastHidden"
            :class="{ hidden: infosPass.id_pass == user.id }"
            class="md:col-span-2 justify-self-center"
            :name="index + 'derniere_eval'"
            libelle=""
            :disabled="true"
            :value="lastValue(intitule)"
          />

          <AnswerJauge
            v-if="infosPass.id_pass == user.id && !jauge"
            :disabled="false"
            :criteria="form.template[0].criterions"
            :reduced="false"
            :selected="form.items[index].autoEval"
            @select="(answerIndex) => select(index, 'autoEval', answerIndex, form.template[0].criterions)"
          ></AnswerJauge>

          <!-- if last eval is hidden -->
          <div v-if="lastHidden" class="col-span-2 justify-self-center" />

          <input-select
            class="md:col-span-2 justify-self-center"
            :class="{ hidden: infosPass.id_pass == user.id }"
            :name="index + 'nouvelle_eval'"
            libelle=""
            :necessary="true"
            :datas="form.template[0].criterions"
            :value="
              form.items.filter(
                (item) =>
                  (item.name && item.name === intitule.libelle) ||
                  item.description === intitule.description
              )[0].refEval
            "
            @input="
              (newValue) => {
                $set(form.items[index], 'refEval', newValue);
              }
            "
            :disabled="infosPass.id_pass == user.id ? true : false"
          />

          <icon-comment
            :class="{ hidden: infosPass.id_pass == user.id }"
            :name="'comment-' + index"
            class="cursor-pointer md:col-span-1 lg:place-self-center mr-10"
            :value="form.items[index].comment"
            @input="
              (newValue) => {
                $set(form.items[index], 'comment', newValue);
              }
            "
          />
        </div>
      </div>
      <!-- END display as a table -->

      <!-- display on rows (for MOBILE devices) -->
      <div v-else>
        <div
          v-for="(intitule, index) in form.template[1].criterions"
          :key="index"
          class="odd:bg-indigo-100 odd:bg-opacity-50"
        >
          <div
            class="h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
            :class="{
              'bg-indigo-200 border-l-2 border-indigo-600':
                itemDisplayed == index,
            }"
            @click="displayItem(index)"
            :id="'intitule' + index"
          >
            <div
              class="col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
            >
              <icon
                class="transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': itemDisplayed == index }"
                name="chevron-right"
              />
            </div>
            <div
              class="col-span-1"
            >

            </div>
            <div class="col-span-9 text-base line-clamp-3">
                {{ intitule.description }}
            </div>
          </div>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-show="itemDisplayed === index"
              class="bg-white my-5 w-full relative flex flex-col space-y-4 px-5"
            >
              <TextToSpeech
                class="self-center"
                :speak="intitule.description"
              ></TextToSpeech>

              <input-text-area
                libelle="Intitulé"
                :value="intitule.libelle"
                :disabled="true"
                :size="3"
              />

              <input-select
                v-if="!autoHidden && !jauge"
                :name="index + 'auto_eval'"
                :disabled="autoEvalDisabled"
                :datas="form.template[0].criterions"
                :value="form.items[index].autoEval"
                @input="
                  (newValue) => {
                    $set(form.items[index], 'autoEval', newValue);
                  }
                "
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="autoHidden ? 'eye-off' : 'eye'"
                @clickIcon="
                  $can('compsocio_auto_eval_read', idPass)
                    ? hide('autoEval')
                    : null
                "
              />
              <input-select
                v-if="autoHidden && !jauge"
                :name="index + 'auto_eval'"
                :datas="form.template[0].criterions"
                :value="''"
                :disabled="true"
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="autoHidden ? 'eye-off' : 'eye'"
                @clickIcon="
                  $can('compsocio_auto_eval_read', idPass)
                    ? hide('autoEval')
                    : null
                "
              />
              <AnswerJauge
                v-if="!autoHidden && jauge"
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="autoHidden ? 'eye-off' : 'eye'"
                @clickIcon="
                  $can('compsocio_auto_eval_read', idPass)
                    ? hide('autoEval')
                    : null
                "
                :disabled="false"
                :criteria="form.template[0].criterions"
                :reduced="false"
                :selected="form.items[index].autoEval"
                @select="(answerIndex) => select(index, 'autoEval', answerIndex, form.template[0].criterions)"
              ></AnswerJauge>
              <AnswerJauge
                libelle="Auto-évaluation"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="autoHidden ? 'eye-off' : 'eye'"
                @clickIcon="
                  $can('compsocio_auto_eval_read', idPass)
                    ? hide('autoEval')
                    : null
                "
                v-if="autoHidden && jauge"
                :disabled="true"
                :criteria="form.template[0].criterions"
                :reduced="false"
              ></AnswerJauge>

              <input-text
                :class="{ hidden: infosPass.id_pass == user.id }"
                :name="index + 'derniere_eval'"
                :disabled="true"
                :value="lastValueMobile(intitule)"
                libelle="Dernière évaluation du référent"
                libelle-style="text-base text-indigo-600"
                :libelle-icon="lastHidden ? 'eye-off' : 'eye'"
                @clickIcon="hide('lastEval')"
              />

              <input-select
                :class="{ hidden: infosPass.id_pass == user.id }"
                :name="index + 'nouvelle_eval'"
                :necessary="true"
                :datas="form.template[0].criterions"
                :value="
                  form.items.filter(
                    (item) =>
                      (item.name && item.name === intitule.libelle) ||
                      item.description === intitule.description
                  )[0].refEval
                "
                @input="
                  (newValue) => {
                    $set(form.items[index], 'refEval', newValue);
                  }
                "
                :disabled="infosPass.id_pass == user.id ? true : false"
                libelle="Nouvelle évaluation du référent"
                libelle-style="text-base text-indigo-600"
              />

              <input-text-area
                :class="{ hidden: infosPass.id_pass == user.id }"
                :name="'comment-' + index"
                libelle="Commentaire"
                :value="
                  form.items.filter((item) => item.name === intitule.libelle)[0]
                    .comment
                "
                :size="3"
                @input="
                  (newValue) => {
                    $set(form.items[index], 'comment', newValue);
                  }
                "
              />
            </div>
          </transition>
        </div>
      </div>
      <!-- END display on rows (for mobile devices) -->

      <input-text-area
        v-if="form.template[2] && form.template[2].isDisplayed"
        :class="{ hidden: infosPass.id_pass == user.id }"
        class="px-10 mt-10"
        name="comment"
        libelle="Commentaire général"
        :value="form.comment"
        :size="3"
        @input="
          (newValue) => {
            $set(form, 'comment', newValue);
          }
        "
      />
    </div>
    <!-- END Evaluation content -->
  </div>
  <div v-else>
    <h3 class="my-15 w-full">Accès restreint</h3>
    <div>
      <div class="text-gray-600 text-lg text-center">
        <p>
          Veuillez ajouter un
          <router-link :to="{ name: 'PermissionsGuests' }">
            <span class="cursor-pointer text-indigo-500 underline">invité</span>
          </router-link>
          pour accéder à cette évaluation.
        </p>
      </div>
      <div class="flex justify-center w-full">
        <illustration name="notAllowed" class="mt-15" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import IconComment from '../../../components/Inputs/IconComment';

import ActionButton from '../../../components/ActionButton';
import Icon from '../../../components/Icon';
import Illustration from '../../../components/Illustration';
import Popup from '../../../components/Popup';
import ChangeStructureInput from '../../../components/ChangeStructureInput.vue';

import store from './../../../store';
import axios from './../../../api';

import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import VerifyDates from '../../../mixins/VerifyDates';

import Constants from '../../../constants';
import InfoBulleHover from '../../../components/InfoBulleHover.vue';
import CreateEvaluationPopup from '../../../components/Evaluations/CreateEvaluationPopup.vue';
import ListActionButtons from '../../../components/Evaluations/ListActionButtons.vue';
import CloseEvaluationPopup from '../../../components/Evaluations/CloseEvaluationPopup.vue';
import InfoBulle from '../../../components/InfoBulle.vue';
import TextToSpeech from '../../../components/TextToSpeech.vue';
import AnswerJauge from '../../../components/Inputs/Jauge/AnswerJauge.vue';
import CheckboxIndigo from '../../../components/Inputs/CheckboxIndigo.vue';

export default {
  components: {
    CheckboxIndigo,
    AnswerJauge,
    TextToSpeech,
    InfoBulle,
    ActionButton,
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    IconComment,
    Illustration,
    Popup,
    PopupCompareCarto,
    InfoBulleHover,
    CreateEvaluationPopup,
    ListActionButtons,
    CloseEvaluationPopup,
    ChangeStructureInput,
  },

  props: ['progressbar'],
  name: 'RefMulti2',

  mixins: [VerifyDates],

  data() {
    return {
      jauge: false,
      constants: Constants,
      isDisplayEvalRefTooltip: false,
      isDisplayLastEvalTooltip: false,
      isDisplayCommentairesTooltip: false,
      form: {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [{}, {}],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      },

      // Initial state of the form
      emptyForm: {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [{}, {}],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      },

      latestEval: {},
      show_add_evaluation: false,
      confirmCloseEvaluation: -1, //-1 : modal closed / 0 : confirm close / 1 : evaluation closed
      autoHidden: true,
      lastHidden: true,

      cartoToCompare: '',
      compareCarto: false,
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      historyToDisplay: -1,
      itemDisplayed: -1,
    };
  },

  //to reinit the new form
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.initPage();
    });
  },

  mounted() {
    if (this.infosPass.id_pass == this.user.id) {
      this.autoHidden = false;
      this.lastHidden = true;
    } else {
      this.autoHidden = true;
      this.lastHidden = true;
    }

    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      SET_INFOSPAGE: 'neopass/SET_INFOSPAGE',
      calculate_progress: 'neopass/calculate_progress',
    }),
    ...mapActions({
      save_datas: 'neopass/save_datas',
      close_evaluation: 'neopass/close_evaluation',
      load_infos_pass: 'cartographiesIndividuelles/load_infos_pass',
      load_evaluations: 'cartographiesIndividuelles/load_evaluations',
    }),

    select( index, type, newValue, criterions) {
      if (newValue === undefined || typeof newValue !== 'number') {
        this.$set(this.form.items[index], type, newValue);
      } else {
        newValue = criterions[newValue].value;
      }
      this.$set(this.form.items[index], type, newValue);
    },

    toggleJaugeDisplay() {
      this.jauge = !this.jauge;
    },

    lastValue(intitule) {
      if (!this.lastEval) {
        return "Pas d'évaluation récente";
      }
      const entries = Object.entries(this.lastEval);

      if (entries.length > 0) {
        return (
          this.lastEval?.items?.filter(
            (item) => item.name === intitule.libelle
          )[0]?.refEval || "Pas d'évaluation récente"
        );
      } else {
        return "Pas d'évaluation récente";
      }
    },

    lastValueMobile(intitule) {
      if (this.lastHidden) {
        return '';
      } else {
        return this.lastValue(intitule);
      }
    },

    hide(field) {
      if (field === 'autoEval') {
        this.autoHidden = !this.autoHidden;
      } else if (field === 'lastEval') {
        this.lastHidden = !this.lastHidden;
      }
    },

    loadEmptyForm() {
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
    },

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },

    async initPage() {
      await store.commit('app/SET_LOADING', true);
      await this.loadEmptyForm();
      await this.initForm();

      this.infosPage.isFormChanged = false;
      store.commit('app/SET_LOADING', false);
    },

    set_last_eval() {
      //to fill the "last evaluation" column
      if (this.listEvaluations.length === 0) {
        this.latestEval = {};
      } else if (this.listEvaluations.length === 1) {
        this.latestEval = this.listEvaluations[0].data;
      } else if (this.listEvaluations.length > 0) {
        this.latestEval = this.listEvaluations.filter(
          (eval0) =>
            Date.parse(eval0.end_at) ===
            Math.max(
              ...this.listEvaluations.map((eval1) => Date.parse(eval1.end_at))
            )
        )[0].data;
      }
    },

    create_evaluation() {
      this.form.id_ref = this.infosPage.id_template;
      axios
        .get('/api/page_templates/' + this.form.id_ref)
        .then((response) => {
          /* Load template for the form */
          let datas = response.data.data;
          let last_version = datas[datas.length - 1];

          this.form.version_template = datas.length;
          this.form.type_temp = response.data.type;
          this.form.name_temp = response.data.name;

          if (last_version.length > 0) {
            this.form.template = last_version;
          } else {
            this.form.template = [];
          }
          this.form.template[1].criterions.forEach((criteria) => {
            this.form.items.push({
              name: criteria.libelle,
              description: criteria.description,
              refEval: '',
              autoEval: '',
              comment: '',
            });
          });

          if (this.form.template[2] && this.form.template[2].isDisplayed) {
            this.form.comment = '';
          }

          this.set_last_eval();
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response.data);
        });

      this.show_add_evaluation = false;
    },

    close_eval() {
      this.close_evaluation(this.form);
      (this.form = {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      }),
        (this.latestEval = {});
      this.confirmCloseEvaluation = 1;
    },

    displayItem(index) {
      if (this.itemDisplayed == index) {
        this.itemDisplayed = -1;
      } else {
        this.itemDisplayed = index;
        let pos = document.getElementById('intitule' + index);
        setTimeout(() => {
          pos.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 800);
      }
    },

    //methods for individual cartography popup
    async displayCompareCarto(typeCarto) {
      await this.load_infos_pass(this.infosPass.id_pass);

      Promise.all([this.load_evaluations()])
        .then(() => {
          this.compareCarto = true;
          this.cartoToCompare = typeCarto;
        })
        .catch((error) => {
          console.error(`Error while loading page: ${error}`);
        });
    },

    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },

    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },
  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      user: 'auth/user',
      role: 'auth/role',
      structures: 'auth/structures',
      listEvaluations: 'neopass/listEvaluations',
      cartoNeopassDatas: 'cartographiesIndividuelles/neopassDatas',
      cartoListEvaluations: 'cartographiesIndividuelles/listEvaluations',
    }),

    lastEval() {
      if (this.listEvaluations.length === 0) {
        return undefined;
      } else if (this.listEvaluations.length === 1) {
        return this.listEvaluations[0].data;
      } else if (this.listEvaluations.length > 0) {
        return this.listEvaluations.filter(
          (eval0) =>
            Date.parse(eval0.end_at) ===
            Math.max(
              ...this.listEvaluations.map((eval1) => Date.parse(eval1.end_at))
            )
        )[0].data;
      }

      return undefined;
    },

    evalStartDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };

      if (this.form.date_debut_evaluation !== '') {
        return new Date(this.form.date_debut_evaluation).toLocaleDateString(
          undefined,
          options
        );
      } else {
        return new Date().toLocaleDateString(undefined, options);
      }
    },

    today() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date().toLocaleDateString(undefined, options);
    },

    autoEvalDisabled() {
      /**
       *  enable auto eval if : (User is owner OU User is particulier with at least one guest) AND has permission to edit eval
       *  So, to disable, make contrary
       * */
      let isNeopassOwner = parseInt(this.infosPass.id_pass) === this.user.id;

      let pageName = this.infosPage.name_page;
      let canEdit = this.$can(pageName + '_edit', this.infosPass.id_pass);
      let canEditAutoEval = this.$can(
        'compsocio_auto_eval_edit',
        this.infosPass.id_pass
      );
      return !(
        ((isNeopassOwner || this.$hasAtLeastOneGuest()) && canEdit) ||
        canEditAutoEval
      );
    },

    canCompare() {
      return this.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE);
    },

    competencesSocioPro: function () {
      //Ref_multi2
      return (
        (this.cartoNeopassDatas || {})[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
        ] || {}
      );
    },

    historyCompetencesSocioPro: function () {
      return (
        (this.cartoListEvaluations || {})[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
        ] || {}
      );
    },

    historiesToCompare() {
      let histories = {};

      histories[this.infosPage.name_page] = (
        (this.historyCompetencesSocioPro || {})[this.infosPage.name_page] || []
      ).filter((h) => h.template_name == this.infosPage.libelle_template);

      return histories;
    },
  },
  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },
};
</script>
